import Editor from '@monaco-editor/react';

interface JsonViewerProps {
    src: unknown;
    height?: string;
}

const JsonViewer = ({ src, height = '30rem' }: JsonViewerProps) => (
    <Editor
        height={height}
        language="json"
        theme="vs-light"
        value={JSON.stringify(src, null, 2)}
        options={{
            automaticLayout: true,
            folding: true,
            lineNumbers: 'on',
            minimap: { enabled: false },
            readOnly: true,
            scrollBeyondLastLine: false,
            showFoldingControls: 'always',
            wordWrap: 'on',
        }}
    />
);

export default JsonViewer;
